export class Board {
    id : number;
    boardCode : string;
    boardName : string;
}